import { useEffect, useRef } from "react";
import styled from "styled-components";

type PanelPlayProps = {
  filePath: string;
  autoPlay?: boolean;
  muted?: boolean;
  width?: number;
  currentTime?: number;
  loop?: boolean;
};

const PanelPlay = ({
  filePath,
  autoPlay,
  muted,
  width,
  currentTime,
  loop,
}: PanelPlayProps) => {
  const panelRef = useRef<HTMLOptionElement | null>(null);
  const mutedValue: boolean = typeof muted !== "undefined" ? muted : true;
  const widthValue: number = typeof width !== "undefined" ? width : 250;
  useEffect(() => {
    if (panelRef.current) {
      if (currentTime) {
        // panelRef.current.currentTime = currentTime;
      }
    }
  }, []);

  return (
    <DivPlay>
      {/* <panel
        ref={panelRef}
        controls
        width={widthValue}
        autoPlay={autoPlay}
        muted={mutedValue}
        loop={loop}
      >
        <source src={filePath} type="panel/mp4" />
        Download the
        <a href={filePath}>MP4</a>
        panel.
      </panel> */}
    </DivPlay>
  );
};

const DivPlay = styled.div`
  display: flex;
`;

export default PanelPlay;
